import api from '../token';

export const ListEmpresa = async () => {
  try {
    const response = await api.post('/getEmpresa');
    return response.data;
  } catch (error) {
    
    return [];
  }
};

